<template>
  <v-row dense align="center">
    <v-col v-if="showDay">
      <span class="text-capitalize">{{ dayLabel }}</span>
      <v-chip 
        v-if="!entry.isUserOpen" 
        color="error" 
        class="float-right" 
        small
      >
        Fermé
      </v-chip>
    </v-col>
    <template v-for="(field, index) in fields">
      <v-col :key="'fieldInput' + index">
        <EntryFormInput 
          v-model="entry[field.key]"
          :disabled="field.key === 'comment' ? !entry.canComment : entry.disabled"
          :invalid="validation && validation[field.key].$invalid"
          :icon="field.icon"
          :type="field.type"
          @edited="$emit('edited')"
        />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import EntryFormInput from '@/components/Entry/EntryFormInput'
export default {
  name: 'EntryFormRow',
  components: {EntryFormInput},
  props: {
    fields: {type: Array, required: true},
    value: {type: Object, required: true},
    showDay: {type: Boolean, required: false},
    validation: {type: Object, required: false}
  },
  computed: {
    dayLabel () {
      return this.entry.dateISO && this.entry.dateISO.toLocaleString('fr-FR', {weekday: 'long'})
    },
    entry: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
